import React, { useState } from "react";
import { bankingPartnerAPI } from "../../../services/AdminPortal/api";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "react-hot-toast";

const EditBankingPartnerModal = ({ isOpen, onClose, partner, onUpdate }) => {
  const [formData, setFormData] = useState({
    bankName: partner?.bankName || "",
    bankCategory: partner?.bankCategory || "",
    partnershipDate: partner?.partnershipDate || "",
    password: "", // optional
  });
  console.log(partner,"kkkkkkkkkkkkllllll")

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});

    try {
      // Validation
      if (!formData.bankName.trim()) {
        setErrors({ bankName: "Bank name is required" });
        setIsSubmitting(false);
        return;
      }

      // Optional password validation
      if (formData.password && formData.password.length < 6) {
        setErrors({ password: "Password must be at least 6 characters" });
        setIsSubmitting(false);
        return;
      }

      // Only send password if changed
      const updates = { ...formData };
      if (!updates.password) delete updates.password;

      const response = await bankingPartnerAPI.update(partner._id, updates);

      if (!response?.success) {
        throw new Error(response?.message || "Failed to update partner");
      }

      onUpdate(response.data);
      toast.success("Banking partner updated successfully!");
      onClose();
    } catch (error) {
      const errorMessage = error.message || "Failed to update partner";
      toast.error(errorMessage);
      setErrors({ form: errorMessage });
      console.error("Error updating partner:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#131313] p-6 rounded-lg w-96">
        <h2 className="text-xl font-semibold mb-4 text-white">
          Edit Banking Partner
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Bank Name */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">Bank Name</label>
            <input
              type="text"
              name="bankName"
              value={formData.bankName}
              onChange={handleChange}
              className={`w-full p-2 rounded border ${
                errors.bankName ? "border-red-500" : "border-[#333]"
              } bg-[#131313] text-white`}
            />
            {errors.bankName && (
              <p className="text-red-500 text-xs mt-1">{errors.bankName}</p>
            )}
          </div>

          {/* Bank Category */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">Bank Category</label>
            <input
              type="text"
              name="bankCategory"
              value={formData.bankCategory}
              onChange={handleChange}
              className="w-full p-2 rounded border border-[#333] bg-[#131313] text-white"
            />
          </div>

          {/* Password with toggle */}
          <div className="relative">
            <label className="block text-sm text-gray-300 mb-1">Change Password</label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter new password"
              className={`w-full p-2 rounded border ${
                errors.password ? "border-red-500" : "border-[#333]"
              } bg-[#131313] text-white`}
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute right-2 top-9 text-gray-400"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
            {errors.password && (
              <p className="text-red-500 text-xs mt-1">{errors.password}</p>
            )}
          </div>

          {/* Partnership Date */}
          <div>
            <label className="block text-sm text-gray-300 mb-1">Partnership Date</label>
            <input
              type="date"
              name="partnershipDate"
              value={formData.partnershipDate}
              onChange={handleChange}
              className="w-full p-2 rounded border border-[#333] bg-[#131313] text-white"
            />
          </div>

          {/* Form level error */}
          {errors.form && (
            <p className="text-red-500 text-sm text-center">{errors.form}</p>
          )}

          {/* Buttons */}
          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-4 py-2 bg-customYellow text-black rounded hover:bg-yellow-600 disabled:opacity-50"
            >
              {isSubmitting ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBankingPartnerModal;
